import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import SiteFooter from "./SiteFooter";
import Logo from "./Logo";

/**
 * Wrapper for public/marketing pages (Privacy, Terms, About, Contact).
 * Provides a consistent nav + footer and sets the document title for SEO.
 */
export default function PublicLayout({ title, description, children }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
  }, [title, description]);

  return (
    <div className="min-h-screen bg-zinc-50 dark:bg-zinc-950" data-testid="public-layout">
      <nav className="sticky top-0 z-40 border-b border-zinc-200/50 bg-white/70 backdrop-blur-xl dark:border-zinc-800/50 dark:bg-zinc-950/60">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-2">
            <Logo className="h-9 w-9" />
            <div>
              <div className="font-heading text-lg font-bold leading-none">Syllox</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">Built for Aspirants</div>
            </div>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/login"><Button variant="ghost">Login</Button></Link>
            <Link to="/auth/phone">
              <Button className="bg-emerald-500 hover:bg-emerald-600 text-white">
                Get Started <ArrowRight size={16} className="ml-1"/>
              </Button>
            </Link>
          </div>
        </div>
      </nav>

      <main>{children}</main>

      <SiteFooter />
    </div>
  );
}
